/**
 * Horaires de la boutique, partagés par tous les composants qui en dépendent.
 *
 * Le catalogue affiche des centaines de vignettes : sans mise en commun, chaque
 * carte déclencherait son propre appel. La réponse est donc mémorisée au niveau
 * du module pendant une minute — assez pour couvrir un rendu de page, assez
 * court pour qu'une bascule d'horaire se voie sans recharger.
 */

import { useEffect, useState } from 'react';
import { ecommerceApi, type ShopConfig, type OrderingState } from '../../api/ecommerce.api';

const DUREE_CACHE_MS = 60_000;

let enCours: Promise<ShopConfig> | null = null;
let obtenuA = 0;

export function fetchShopConfigCached(): Promise<ShopConfig> {
  const maintenant = Date.now();
  if (!enCours || maintenant - obtenuA > DUREE_CACHE_MS) {
    obtenuA = maintenant;
    enCours = ecommerceApi.shop.getConfig().catch(err => {
      // Un échec ne doit pas être mémorisé : la prochaine demande réessaie.
      enCours = null;
      throw err;
    });
  }
  return enCours;
}

export function useShopOrdering(): OrderingState | null {
  const [ordering, setOrdering] = useState<OrderingState | null>(null);
  useEffect(() => {
    let annule = false;
    fetchShopConfigCached()
      .then(config => {
        if (!annule) setOrdering(config.ordering);
      })
      // Silencieux : un souci d'horaires ne doit pas masquer le catalogue.
      .catch(() => {});
    return () => {
      annule = true;
    };
  }, []);
  return ordering;
}
